module.exports = __webpack_public_path__ + "img/carousel-02-desktop.aae2190c.png";